export default "__VITE_ASSET__7a831e40__"